import { __assign } from "tslib";
/* eslint react/display-name: 0 */
import * as React from 'react';
import { getStyleParamsWithDefaults } from './getStyleParamsWithDefaults';
export var withDefaultStyleParams = function (WrappedComponent, getDefaultStyleParamsFunc) {
    return function (props) {
        var style = props.host.style;
        var styleWithDefaultStyleParams = __assign(__assign({}, style), { styleParams: getStyleParamsWithDefaults(style.styleParams, function () { return getDefaultStyleParamsFunc(props); }) });
        var host = __assign(__assign({}, props.host), { style: __assign({}, styleWithDefaultStyleParams) });
        return React.createElement(WrappedComponent, __assign({}, props, { style: styleWithDefaultStyleParams, host: host }));
    };
};
//# sourceMappingURL=withDefaultStyleParams.js.map